import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { WelletContext } from '../../context/WelletContext';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import Button from '../../components/Common/Button/Button';
import useForm from '../../helpers/useForm';
import { Spinner } from '../../components/Common/Spinner/Spinner';
import InputPhone from '../../components/Common/InputPhone/InputPhone';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import WhatsAppIcon from '../../components/icons/WhatsAppIcon';
import MessageIcon from '../../components/icons/MessageIcon';

export default function SignUpScreen() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [phoneError, setPhoneError] = useState('');
  const [sendingCode, setSendingCode] = useState(false);
  const [currentMethod, setCurrentMethod] = useState(null);
  const welletContext = useContext(WelletContext);
  const tenantId = useSelector((state) => state.app.tenantId);
  const countryCode = useSelector((state) => state.app.currentMarket.countryCode);
  const email = searchParams.get('email');

  const language = useSelector((state) => state.app.language);
  const { values, errors, handleChange } = useForm(null, validate);

  function validate(values) {
    let errors = {};
    if (!values.phone) {
      errors.phone = t('phoneError.EMPTY_PHONE_NUMBER');
      setPhoneError(errors.phone);
    } else if (!isValidPhoneNumber(values.phone)) {
      errors.phone = t('phoneError.INVALID_PHONE_NUMBER');
      setPhoneError(errors.phone);
    } else {
      setPhoneError('');
    }
    return errors;
  }

  const change = (e) => {
    handleChange({ target: { name: 'phone', value: e }, persist: () => {} });
    setPhoneError('');
  };

  const handleMethodClick = async (method) => {
    setCurrentMethod(method);

    const validationErrors = validate(values);
    if (Object.keys(validationErrors).length > 0) return;

    setSendingCode(true);
    try {
      let queryParams = `?phone=${values.phone}&countryCode=${countryCode}&method=${method}`;

      if (email) {
        queryParams += `&email=${email}`;
      }

      await welletContext.apis.tickets.post(`users/code`, {
        Phone: values.phone,
        tenantId: tenantId,
        countryCode: countryCode,
        language: language,
        SendCodeValidationTarget: method,
      });

      history.push({
        pathname: '/sign-up-phone-validation',
        search: queryParams,
      });
    } catch (error) {
      let errorMessage;
      switch (error.response?.data?.errorCode) {
        case 'PHONE_NOT_AVAILABLE':
          errorMessage = t('phoneError.PHONE_NUMBER_ALREADY_IN_USE');
          break;
        case 'MAX_ATTEMPTS':
          errorMessage = t('phoneError.MAXIMUM_ATTEMPTS');
          break;
        case 'SEND_FAILURE':
          errorMessage = t('phoneError.SEND_FAILURE');
          break;
        default:
          errorMessage = t('callApiError');
      }
      setPhoneError(errorMessage);
    }
    setSendingCode(false);
  };

  return (
    <>
      <Header pathName={`/`} hasBackground={true} />
      <ContentApp background={true}>
        <div className='font-medium bold' style={{ color: '#fff' }}>
          {t('signUp.title1')}
        </div>
        <div className='mt-1 text-secondary subtitle'>{t('signUp.subtitle1')}</div>
        <div className='mt-4'>
          <InputPhone
            placeholder={t('mobile')}
            onHandleChange={change}
            error={phoneError}
            t={t}
            countryCode={countryCode}
          />
        </div>
        {/* {tenantId === 'link-shuttle-0wvxw' || tenantId === 'extreme-adventuring-3lxmy' ? (
          <div className='mt-3 d-flex justify-content-center'>
            <Button
              backgroundColor={'#fff'}
              typeIcon={<MessageIcon size='18px' color='#000'></MessageIcon>}
              icon={true}
              fontSize='16px'
              size='large'
              className={`btn-secondary `}
              text={
                sendingCode && currentMethod === 'SMS' ? (
                  <Spinner size={20} color='#000' />
                ) : (
                  t('signUp.sendBySMS')
                )
              }
              onClick={() => handleMethodClick('SMS')}
              disabled={sendingCode}
            />
          </div>
        ) : ( */}
        <div className='mt-4 d-flex justify-content-center'>
          <Button
            icon={true}
            fontSize='16px'
            size='large'
            className={`btn-primary `}
            text={
              <div style={{ minWidth: 140, display: 'flex', justifyContent: 'center' }}>
                {sendingCode && currentMethod === 'WHATSAPP' ? (
                  <Spinner size={20} color='#000' />
                ) : (
                  <div className='d-flex align-items-center' style={{ gap: 5 }}>
                    {t('signUp.sendByWhatsApp')}{' '}
                    {<WhatsAppIcon size='16px' color='#fff'></WhatsAppIcon>}
                  </div>
                )}
              </div>
            }
            onClick={() => handleMethodClick('WHATSAPP')}
            disabled={sendingCode}
          />
        </div>
        {/* // )} */}
      </ContentApp>
    </>
  );
}
